import icon from '../../dist/ionicons/svg/logo-nodejs.svg'

export default /*#__PURE__*/ icon;